
import Vue from 'vue'

import { QTabs, QTab, QTabPanels, QTabPanel, QRadio, QInput, QSelect } from 'quasar'
import StateChooserOption from './StateChooserOption.vue'
import getPauseOptions from '@/helpers/pauseOptions'
import states from '@/helpers/states'

export default Vue.extend({
    components: { QTabs, QTab, QTabPanels, QTabPanel, QRadio, QInput, QSelect, StateChooserOption },
    props: {
        lastStateKey: {
            type: String
        },
        state: {
            type: String
        },
        pauseDuration: {
            type: Number,
        },
        comment: {
            type: String,
        }
    },
    data() {
        return {
            tab: 'no',
            iPause: null,
            iComment: ''
        }
    },
    computed: {
        pauseOptions() {
            return getPauseOptions()
        }
    },
    watch: {
        iPause(val) {
            this.$emit('update:pauseDuration', val.value)
        },
        iComment(val) {
            this.$emit('update:comment', val)
        }
    },
    created() {
      // pre select the most likely tab
      if(['agreedWayUnclear', 'agreedSending', 'agreedSent', 'agreedPickupOffered', 'agreedPickupOrganized', 'agreedExtern', 'foodRecieved', 'done'].includes(this.lastStateKey)) {
        this.tab = 'yes'
      }
    },
    methods: {
        onStateClick(key) {
            // this.state = key
            // console.
            this.$emit('update:state', key)
            const state = states[key]
            console.log({state})
            if(state && state.defaultPause !== undefined) {
                console.log('update', this.pauseOptions.find(p => p.value === state.defaultPause))
                // @ts-ignore   
                this.iPause = this.pauseOptions.find(p => p.value === state.defaultPause)
            }
            console.log({key})
        }
    }
})
